import calendar from "../pages/calendar/calendar";
import _ from "./datetime";

const weekList = ['日', '一', '二', '三', '四', '五', '六'];

const ONE_DAY = 24 * 3600 * 1000;

const createDate = (dateString) => {
  if (typeof dateString === 'string') {
    dateString = dateString.split('.')[0];
  }

  if (dateString.replace) {
    dateString = dateString.replace(/\-/g, '/');
  }

  return (new Date(dateString));
};
const formatNewDate = (dateString) => {
  let year = dateString.getFullYear();
  let month = dateString.getMonth() + 1;
  let day = dateString.getDate();
  return year + '-' + format(month) + '-' + format(day);
}

const getTimestamp = (dateString) => {
  return createDate(dateString).getTime();
};

const getCurrentGMT8Time = () => {
  var date = new Date();
  var t = date.getTime() + (480 + date.getTimezoneOffset()) * 60000;
  return t;
}

const setDateToMidnight = (dateObject) => {
  dateObject.setHours(0);
  dateObject.setMinutes(0);
  dateObject.setSeconds(0);
  dateObject.setMilliseconds(0);

  return dateObject;
};

const getDateAlias = (dateString) => {
  let dateAlias;

  const offset = getDateDiff(dateString);

  if (offset < -2) {
    dateAlias = Math.abs(offset) + '天前';
  } else if (offset === -2) {
    dateAlias = '前天';
  } else if (offset === -1) {
    dateAlias = '昨天';
  } else if (offset === 0) {
    dateAlias = '今天';
  } else if (offset === 1) {
    dateAlias = '明天';
  } else if (offset === 2) {
    dateAlias = '后天';
  } else {
    dateAlias = offset + '天后';
  }

  return dateAlias;
}

const getDateDiff = (dateString) => {
  const day = 24 * 60 * 60 * 1000;
  const today = setDateToMidnight(new Date()).getTime();
  const dateTimeStamp = setDateToMidnight(createDate(dateString)).getTime();
  const offset = Math.round((dateTimeStamp - today) / day);

  return offset;
}

const getLunarDate = (dateString) => {
  dateString = dateString.split('-');

  const year = dateString[0];
  const month = dateString[1];
  const day = dateString[2];
  const lunarDate = calendar.solarToLunar(year, month, day);

  return lunarDate.lunarMonthName + lunarDate.lunarDayName;
};

const getLunarFestival = (dateString) => {
  // console.log(typeof(dateString),11111111111);
  if (typeof(dateString) === 'object') {
    dateString = formatNewDate(dateString);
  }
  dateString = dateString.split('-');

  const year = dateString[0];
  const month = dateString[1];
  const day = dateString[2];
  const lunarDate = calendar.solarToLunar(year, month, day);
  return lunarDate.lunarFestival;
}

const getSolarDate = (dateString) => {
  dateString = createDate(dateString);

  const month = dateString.getMonth() + 1;
  const date = dateString.getDate();

  return month + '月' + date + '日';
};

const getYearDate = (dateString) => {
  dateString = createDate(dateString);

  const year = dateString.getFullYear();
  const month = dateString.getMonth() + 1 < 10 ? '0' + (dateString.getMonth() + 1) : dateString.getMonth() + 1;
  const date = dateString.getDate() < 10 ? '0' + dateString.getDate() : dateString.getDate();

  return year + '-' + month + '-' + date;
}

const getWeekDay = (dateString, prefix = '星期') => {
  dateString = createDate(dateString);

  return prefix + weekList[dateString.getDay()];
};

const format = (data) => {
  if (parseInt(data) < 10) {
    data = '0' + parseInt(data);
  }

  return data;
};

const getClockTime = (dateString) => {
  dateString = createDate(dateString);

  const hour = dateString.getHours();
  const minute = dateString.getMinutes();

  return format(hour) + ':' + format(minute);
};

const timestampToDateString = (timestamp) => {
  const time = createDate(timestamp);
  const year = time.getFullYear();
  const month = format(time.getMonth() + 1);
  const date = format(time.getDate());

  return year + '-' + month + '-' + date;
};

const compare = (left, right, option) => {
  var leftDate = createDate(left),
    rightDate = createDate(right);
  if (!leftDate || !rightDate) return null;

  if (option === 'date' || option === 'd') {
    leftDate.setHours(0, 0, 0, 0);
    rightDate.setHours(0, 0, 0, 0);
  }

  return leftDate.getTime() - rightDate.getTime();
};

//取北京时间
const getBeijingDate = () => {
  let d = new Date()
  let localTime = d.getTime()
  let localOffset = d.getTimezoneOffset() * 60000 //获得当地时间偏移的毫秒数
  let utc = localTime + localOffset //utc即GMT时间
  let offset = 8 //北京东8区
  let beijing = utc + (3600000 * offset)
  beijing = new Date(beijing)

  return beijing
}

//计算倒计时
const getDeadlineTime = (deadline) => {
  deadline = _.toDate(deadline).getTime()
  let now = new Date().getTime()
  let duration = deadline - now
  let minute = Math.floor(duration / (60 * 1000))
  let second = Math.floor((duration - minute * 60 * 1000) / 1000)

  if (minute < 10) {
    minute = '0' + minute
  }

  if (second < 10) {
    second = '0' + second
  }

  return {
    duration,
    time: `${minute}:${second}`
  }
}

const diffDay = _.diffDay

export {
  ONE_DAY,
  createDate,
  formatNewDate,
  getTimestamp,
  getCurrentGMT8Time,
  getDateAlias,
  getDateDiff,
  getLunarDate,
  getSolarDate,
  getWeekDay,
  format,
  getClockTime,
  timestampToDateString,
  getLunarFestival,
  getBeijingDate,
  compare,
  getDeadlineTime,
  getYearDate,
  diffDay
};

export default {
  ONE_DAY,
  createDate,
  formatNewDate,
  getTimestamp,
  getCurrentGMT8Time,
  getDateAlias,
  getDateDiff,
  getLunarDate,
  getSolarDate,
  getWeekDay,
  format,
  getClockTime,
  timestampToDateString,
  getLunarFestival,
  getBeijingDate,
  compare,
  getDeadlineTime,
  getYearDate,
  diffDay
};



// WEBPACK FOOTER //
// ./src/utils/time-utility.js